/* ag-nautical.js - AquaGrip CT (v78, 26 Oct 2026, Claude)
   1. Background wave video behind the studio hero and the home studio band.
      Muted, looped, starts only when the section is on screen, pauses when it
      leaves. Skipped for reduced motion / Save-Data, and the home video is
      skipped on phones (the poster image shows instead).
   2. Pattern / colour swatches become a centred carousel: the selected swatch
      sits big in the middle with the others stepping down to both sides.
   The snippet loads on every page (header group) and again on studio/home
   pages; the guard below makes the second copy do nothing.
   Reads window.AGN (set by snippets/ag-nautical.liquid). Touches no cart, no
   form and no studio code. */
(function(){
  'use strict';
  if(window.__agnLoaded) return; window.__agnLoaded = true;
  var C = window.AGN || {};
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var saveData = navigator.connection && (navigator.connection.saveData || /2g/.test(navigator.connection.effectiveType || ''));

  /* ---------- 1. background video ---------- */
  function addVideo(section, src, minWidth){
    if(!section || !src || reduce || saveData) return;
    if(minWidth && window.innerWidth < minWidth) return;
    if(section.querySelector('.agn-vid')) return;
    var wrap = document.createElement('div');
    wrap.className = 'agn-vid';
    wrap.setAttribute('aria-hidden','true');
    var v = document.createElement('video');
    v.muted = true; v.loop = true; v.playsInline = true;
    v.setAttribute('muted',''); v.setAttribute('playsinline',''); v.setAttribute('preload','none');
    wrap.appendChild(v);
    section.insertBefore(wrap, section.firstChild);
    section.classList.add('agn-has-vid');
    var loaded = false;
    function play(){
      if(!loaded){ v.src = src; loaded = true; }
      var p = v.play(); if(p && p.catch) p.catch(function(){});
    }
    v.addEventListener('playing', function(){ wrap.classList.add('is-on'); });
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(es){
        es.forEach(function(e){ if(e.isIntersecting) play(); else if(loaded) v.pause(); });
      },{rootMargin:'200px 0px'}).observe(section);
    } else { play(); }
  }

  /* ---------- 2. swatch carousel (v78c) ----------
     The selected swatch sits big in the middle; the others step down to both
     sides. Scroll, drag, swipe, arrows, arrow keys or a tap moves it; the name
     and price under it follow the swatch in the middle. */
  function buildSwatches(opt){
    var tiles = opt.querySelector('.ag-tiles');
    if(!tiles || opt.querySelector('.agn-sw')) return;
    var label = (opt.querySelector('.k') || {}).textContent || '';
    opt.classList.add('agn-has-sw');
    /* 6 or fewer options: medium cards in a centred row, no carousel (v78d) */
    if(tiles.querySelectorAll('.ag-tile').length <= 6){
      var st = document.createElement('div'); st.className = 'agn-sw agn-sw--static';
      tiles.parentNode.insertBefore(st, tiles); st.appendChild(tiles);
      return;
    }
    var box = document.createElement('div'); box.className = 'agn-sw';
    var rail = document.createElement('div'); rail.className = 'agn-sw__rail';
    var meta = document.createElement('div'); meta.className = 'agn-sw__meta'; meta.setAttribute('aria-live','polite');
    meta.innerHTML = '<span class="agn-sw__kicker"></span><span class="agn-sw__name"></span><span class="agn-sw__price"></span><span class="agn-sw__count"></span>';
    var bPrev = document.createElement('button'); bPrev.type='button'; bPrev.className='agn-sw__arrow is-prev'; bPrev.setAttribute('aria-label','Previous '+label.toLowerCase()); bPrev.innerHTML='&#8592;';
    var bNext = document.createElement('button'); bNext.type='button'; bNext.className='agn-sw__arrow is-next'; bNext.setAttribute('aria-label','Next '+label.toLowerCase()); bNext.innerHTML='&#8594;';
    tiles.parentNode.insertBefore(box, tiles);
    rail.appendChild(bPrev); rail.appendChild(tiles); rail.appendChild(bNext);
    box.appendChild(rail); box.appendChild(meta);
    meta.querySelector('.agn-sw__kicker').textContent = label;
    var nameEl = meta.querySelector('.agn-sw__name'), priceEl = meta.querySelector('.agn-sw__price'), countEl = meta.querySelector('.agn-sw__count');
    var list = Array.prototype.slice.call(tiles.querySelectorAll('.ag-tile'));
    var current = -1;

    function setActive(i){
      if(i < 0 || i >= list.length || i === current) return;
      current = i;
      list.forEach(function(t, k){
        var d = Math.abs(k - i);
        t.classList.toggle('is-active', d === 0);
        t.classList.toggle('is-near', d === 1);
        t.setAttribute('aria-pressed', d === 0 ? 'true' : 'false');
      });
      var t = list[i], cap = t.querySelector('.cap'), up = t.querySelector('.up');
      nameEl.textContent = cap ? cap.textContent : '';
      priceEl.textContent = up ? up.textContent + ' upgrade' : 'Standard — no upcharge';
      priceEl.classList.toggle('is-up', !!up);
      countEl.textContent = (i + 1) + ' / ' + list.length;
      bPrev.disabled = i === 0; bNext.disabled = i === list.length - 1;
      meta.classList.remove('is-swap'); void meta.offsetWidth; meta.classList.add('is-swap');
    }
    function centre(i, smooth){
      var t = list[i]; if(!t) return;
      var left = t.offsetLeft - (tiles.clientWidth - t.offsetWidth) / 2;
      tiles.scrollTo({left: left, behavior: (smooth && !reduce) ? 'smooth' : 'auto'});
      setActive(i);
    }
    function nearest(){
      var mid = tiles.scrollLeft + tiles.clientWidth / 2, best = 0, bd = Infinity;
      list.forEach(function(t, k){ var c = t.offsetLeft + t.offsetWidth / 2, d = Math.abs(c - mid); if(d < bd){ bd = d; best = k; } });
      return best;
    }
    var raf = 0;
    tiles.addEventListener('scroll', function(){ if(raf) return; raf = requestAnimationFrame(function(){ raf = 0; setActive(nearest()); }); }, {passive:true});

    list.forEach(function(t, k){
      var cap = t.querySelector('.cap'), up = t.querySelector('.up');
      t.setAttribute('tabindex','0');
      t.setAttribute('role','button');
      t.setAttribute('aria-label', (cap ? cap.textContent : '') + (up ? ', ' + up.textContent : ', standard'));
      t.addEventListener('click', function(){ centre(k, true); });
      t.addEventListener('keydown', function(e){
        if(e.key === 'ArrowRight' && list[k+1]){ e.preventDefault(); centre(k+1, true); list[k+1].focus({preventScroll:true}); }
        if(e.key === 'ArrowLeft' && list[k-1]){ e.preventDefault(); centre(k-1, true); list[k-1].focus({preventScroll:true}); }
        if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); centre(k, true); }
      });
    });
    bPrev.addEventListener('click', function(){ centre(Math.max(0, current - 1), true); });
    bNext.addEventListener('click', function(){ centre(Math.min(list.length - 1, current + 1), true); });
    window.addEventListener('resize', function(){ centre(current < 0 ? 0 : current, false); });

    /* drag with a mouse; a drag never counts as a tap */
    var down = false, sx = 0, sl = 0, moved = false;
    tiles.addEventListener('pointerdown', function(e){ if(e.pointerType !== 'mouse') return; down = true; moved = false; sx = e.clientX; sl = tiles.scrollLeft; });
    window.addEventListener('pointermove', function(e){ if(!down) return; var dx = e.clientX - sx; if(Math.abs(dx) > 4){ moved = true; tiles.classList.add('is-dragging'); } tiles.scrollLeft = sl - dx; });
    window.addEventListener('pointerup', function(){ if(!down) return; down = false; tiles.classList.remove('is-dragging'); if(moved) centre(nearest(), true); });
    tiles.addEventListener('click', function(e){ if(moved){ e.stopPropagation(); e.preventDefault(); moved = false; } }, true);

    /* open on the middle swatch so there are swatches on both sides */
    var start = Math.floor((list.length - 1) / 2);
    centre(start, false);
    window.addEventListener('load', function(){ centre(current < 0 ? start : current, false); });
  }

  /* ---------- 3. mega menu (v78d) ----------
     Glass panel (CSS in ag-site.css), an icon on each column heading, and the
     photo on the right follows whatever link you point at, with its name on
     it. Photos come from window.AGN_MENU (built in sections/ag-site-style.liquid
     from the menu's own collections and products) or the theme's data-image. */
  var ICONS = {
    custom: '<path d="M14 4l6 6L9 21H3v-6z"/><path d="M12 6l6 6"/>',
    boat: '<circle cx="12" cy="5" r="2"/><path d="M12 7v14"/><path d="M5 12H3a9 9 0 0 0 18 0h-2"/><path d="M8 10h8"/>',
    ruler: '<rect x="2" y="7" width="20" height="10" rx="2"/><path d="M6 7v4M10 7v3M14 7v4M18 7v3"/>',
    fish: '<path d="M3 12c3-5 9-6 14-3l4-3v12l-4-3c-5 3-11 2-14-3z"/><circle cx="14" cy="11" r=".9"/>'
  };
  function iconFor(t){
    t = t.toLowerCase();
    var k = /custom/.test(t) ? 'custom' : /ruler|cooler/.test(t) ? 'ruler' : /fish/.test(t) ? 'fish' : 'boat';
    return '<span class="agn-mm-ico" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">' + ICONS[k] + '</svg></span>';
  }
  function megaMenus(){
    var map = window.AGN_MENU || {};
    Array.prototype.forEach.call(document.querySelectorAll('details.mega-menu .mega-menu__content'), function(c){
      if(c.classList.contains('agn-mm')) return;
      c.classList.add('agn-mm');
      Array.prototype.forEach.call(c.querySelectorAll('.mega-menu__link--level-2'), function(a){
        if(!a.querySelector('.agn-mm-ico')) a.insertAdjacentHTML('afterbegin', iconFor(a.textContent));
      });
      var wrap = c.querySelector('.js-megaMenuImgWrp');
      if(!wrap) return;
      var img = wrap.querySelector('img');
      var cap = document.createElement('a'); cap.className = 'agn-mm-cap'; cap.href = '/collections/custom-products';
      cap.innerHTML = '<span class="agn-mm-cap__k">Featured</span><span class="agn-mm-cap__t">Custom builds, cut to order</span><span class="agn-mm-cap__go">Shop now &rarr;</span>';
      wrap.appendChild(cap);
      var tName = cap.querySelector('.agn-mm-cap__t'), tKick = cap.querySelector('.agn-mm-cap__k');
      var last = '';
      function point(a){
        var href = a.getAttribute('href') || '';
        var src = map[href] || a.getAttribute('data-image') || '';
        var name = a.textContent.replace(/\s+/g, ' ').trim();
        var col = a.closest('.mega-menu__list > li');
        var head = col && col.querySelector('.mega-menu__link--level-2');
        tKick.textContent = head && head !== a ? head.textContent.replace(/\s+/g, ' ').trim() : 'Shop';
        tName.textContent = name; cap.href = href || cap.href;
        if(img && src && src !== last){
          last = src;
          wrap.classList.add('is-swap');
          var pre = new Image();
          pre.onload = function(){ img.removeAttribute('srcset'); img.src = src; wrap.classList.remove('is-swap'); };
          pre.onerror = function(){ wrap.classList.remove('is-swap'); };
          pre.src = src;
        }
      }
      Array.prototype.forEach.call(c.querySelectorAll('.mega-menu__link'), function(a){
        a.addEventListener('mouseenter', function(){ point(a); });
        a.addEventListener('focus', function(){ point(a); });
      });
    });
  }

  function init(){
    megaMenus();
    addVideo(document.querySelector('.ag-hero'), C.heroVideo, 0);
    addVideo(document.querySelector('section[data-agsp]'), C.homeVideo, 700);
    Array.prototype.forEach.call(document.querySelectorAll('.ag-spec .ag-spec-opt'), buildSwatches);
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
